import sdmx from "./sdmx";
import common from './sdmx/common';
import commonreferences from './sdmx/commonreferences';
import structure from './sdmx/structure';
import message from './sdmx/message';
import data from './sdmx/data';
import time from './sdmx/time';
import registry from './sdmx/registry';
import parser from './sdmx/parser';
import config from './sdmx/config';
import xml from './sdmx/xml';
export default {
    SdmxIO: sdmx.SdmxIO,
    sdmx:sdmx,
    commonreferences:commonreferences,
    common:common,
    structure:structure,
    message:message,
    data:data,
    time:time,
    parser:parser,
    config:config,
    xml:xml
}